// duprApiWeb.ts
import { initDuprApi } from '@/app/commons/network/duprApiCore'
import { store } from '@/app/store'
import { BASE_API_URL, COOKIE_SESSION } from '@/constants/Common'
import { setToken, setRefresh, resetAuth } from '@/pages/auth/authSlice'
import { resetClub } from '@/pages/club/clubSlice'
import { resetEvent } from '@/pages/event/eventSlice'
import { resetPlayer } from '@/pages/player/playerSlice'
import { resetUser } from '@/pages/user/userSlice'
import { logout } from '@/services/user'
import toast from 'react-hot-toast'

function hardLogout() {
  // Authenticated by the session cookie; the server clears it. No bearer to pass.
  logout()
  store.dispatch(resetAuth())
  store.dispatch(resetUser())
  store.dispatch(resetEvent())
  store.dispatch(resetPlayer())
  store.dispatch(resetClub())
}

export function bootstrapDuprApi() {
  initDuprApi({
    basePath: BASE_API_URL,
    // The first-party session rides the HttpOnly cookie (sent via withCredentials), so the client
    // never holds a real token — these return '' so no bearer is attached. The redux `auth.token`
    // marker is only the "is there a session?" flag and must not leak onto the wire.
    getAccessToken: () => '',
    getRefreshToken: () => '',
    writeTokens: () => {
      // Nothing to persist client-side; the server rotates the cookies. Keep the session marker.
      store.dispatch(setToken(COOKIE_SESSION))
      store.dispatch(setRefresh(COOKIE_SESSION))
    },
    onRefreshFailure: () => {
      toast.error('Session Expired', { id: 'Expired' })
      hardLogout()
    },
  })
}
